define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/def/Field",
	"./FormWithLocale"
], function(declare,lang,Field,FormWithLocale) {

	return declare(FormWithLocale, {
		_resolveView: function() {
		    // DE25367 Refresh data sheets should not be displayed for print CoverSheet view
		    var node = this.getContext().getNode();
		    var fd = this.getFormData();
		    var source = fd ? fd.getSource() : null;
		    if (node && (!source || source.viewId != "CoverSheet")) {
		        var bRefreshDataSheets = node.$Type == "DataPackage"
			        || node.$Type == "SupplierRequest"
			        ||(node.$Type == "SelectSet"
			        && (node.Subtype == "centric://REFLECTION/INSTANCE/SelectSetSubtype/Style" || node.Subtype == "centric://REFLECTION/INSTANCE/SelectSetSubtype/Material"));

				if (bRefreshDataSheets) {
					this.defView.m_fields.push(lang.mixin(new Field(), {
						m_label: "RefreshDataSheets",
						bPersist: true,
						idParameter: "RefreshDataSheets",
						m_typeControl: "Checkbox"
					}));
				}
			}

		    this.inherited(arguments);
		}
	});
});